import type { PipelineStageState } from "contracts/enums/run-stage";
import { For, Show } from "solid-js";

/**
 * One stage of a long-running pipeline, as the UI needs it. Deliberately
 * narrower than the run's `RunStage`: `detail` is whatever the caller wants
 * under the label, so a pipeline with nothing to count (the TOV cascade) does
 * not have to invent counts to satisfy the shape.
 */
export type PipelineStep = {
  key: string;
  label: string;
  state: PipelineStageState;
  detail?: string;
  failed?: number;
};

/**
 * Horizontal stage readout. Shows where work currently is; a stage that failed
 * some of its items still reads as complete once it has drained, with the
 * failure count carried separately.
 */
export function PipelineStepper(props: {
  steps: PipelineStep[];
  compact?: boolean;
}) {
  return (
    <ol class={`pipeline-stepper ${props.compact ? "is-compact" : ""}`}>
      <For each={props.steps}>
        {(step) => (
          <li class="pipeline-step" data-state={step.state}>
            <span class="pipeline-step-label">{step.label}</span>
            <Show when={step.detail}>
              {(detail) => <span class="pipeline-step-count">{detail()}</span>}
            </Show>
            <Show when={step.failed}>
              {(failed) => (
                <span class="pipeline-step-failed">{failed()} failed</span>
              )}
            </Show>
          </li>
        )}
      </For>
    </ol>
  );
}
